import { TYPE } from "@/constants/report";

const REPORT_PERMISSIONS = {
    // Billing Reports
    [TYPE.SALES_BY_PROVIDER_SUMMARY]:
        "report.billing.sales_by_provider_summary",
    [TYPE.SALES_BY_PROVIDER_DETAILS]: "report.billing.sales_by_provider_detail",
    [TYPE.TRANSACTIONS_DETAIL]: "report.billing.transaction_detail",
    [TYPE.ACCOUNTS_RECEIVABLE]: "report.billing.account_receivable",
    [TYPE.PRODUCTION_CREDIT_BY_SALES]:
        "report.billing.production_credit_by_sales",
    [TYPE.PRODUCTION_CREDIT_BY_PAYMENTS]:
        "report.billing.production_credit_by_payments",
    [TYPE.SALES_TAX_SUMMARY]: "report.billing.sales_tax_summary",
    [TYPE.COLLECTION_DETAILS_BY_TYPE]: "report.billing.collection_detail",
    [TYPE.AVERAGE_CLIENT_TRANSACTION]: "report.billing.avg_client_transaction",
    [TYPE.MONTHLY_PAYMENTS_SUMMARY]: "report.billing.monthly_payment",
    [TYPE.MONTHLY_BILLING_SUMMARY]: "report.billing.monthly_billing",
    [TYPE.BILLING_DETAIL]: "report.billing.billing_detail",
    [TYPE.EOD_RECONCILIATION]: "report.billing.eod_reconciliation",
    [TYPE.CASH_RECONCILIATION]: "report.billing.cash_reconciliation",
    [TYPE.OUT_OF_PERIOD_ADJUSTMENTS]: "report.billing.out_of_period_adjustment",
    [TYPE.PAYMENT_BY_PROVIDER]: "report.billing.payment_by_provider",
    [TYPE.DECLINED_ITEMS]: "report.billing.declined_items",
    [TYPE.DISCOUNTS_SUMMARY]: "report.billing.discounts_summary",
    [TYPE.CHARITABLE_FUND]: "report.billing.charitable_fund_summary",
    [TYPE.CREDITS_APPLIED]: "report.billing.credits_applied",
    [TYPE.WRITE_OFFS]: "report.billing.write_off",
    [TYPE.DISCOUNT_DETAILS]: "report.billing.discounts_details",
    [TYPE.CARDS_STORED_ON_FILE]: "report.client.cards_stored_on_file",

    // Patient Reports
    [TYPE.SPECIES_DISTRIBUTION]: "report.patient.species_distribution",
    [TYPE.TOTAL_PATIENTS]: "report.patient.total_patients",
    [TYPE.PATIENT_BIRTHDAYS]: "report.patient.patient_birthday",
    [TYPE.NEW_PATIENTS]: "report.patient.new_patient",
    [TYPE.ACTIVE_PATIENT_LIST]: "report.patient.patient_list",
    [TYPE.DECEASED_PATIENT_LIST]: "report.patient.deceased_patient",
    [TYPE.INACTIVE_PATIENT_LIST]: "report.patient.inactive_patient",
    [TYPE.RABIES_SUMMARY]: "report.patient.rabies_summary",
    [TYPE.ACTIVE_ENGAGED_PATIENT]: "report.patient.active_engaged_patients",
    [TYPE.IN_PROCESS_MEDICAL_NOTES]: "report.patient.in_progress_medical_notes",

    // Client Reports
    [TYPE.ACTIVE_CLIENT_LIST]: "report.client.client_list",
    [TYPE.ACTIVE_ENGAGED_CLIENT_LIST]: "report.client.active_engaged_clients",
    [TYPE.NEW_ENGAGED_CLIENTS]: "report.client.new_engaged_clients",
    [TYPE.PETCARE_CLIENT_LIST]: "report.client.petcare_client_engagement",

    // Inventory Reports
    [TYPE.INVENTORY_SUMMARY]: "report.inventory.summary",
    [TYPE.CONTROLLED_SUBSTANCE_LOG]:
        "report.inventory.controlled_susbstance_log",
    [TYPE.PROFIT_MARGIN]: "report.inventory.profit_margin",
    [TYPE.SALES_BY_ITEM]: "report.inventory.sales_by_item",
    [TYPE.RETURNS]: "report.inventory.25_most_returned",
    [TYPE.INVENTORY_ADJUSTMENTS]: "report.inventory.summary",
    [TYPE.INVENTORY_ALERTS]: "report.inventory.summary",

    // Schedule Reports
    [TYPE.APPOINTMENT_BY_STATUS]: "report.schedule.schedule_appointment",
    [TYPE.SALES_BY_APPOINTMENT_TYPE]:
        "report.schedule.sales_by_appointment_type",
    [TYPE.APPOINTMENT_LOG]: "report.schedule.appointment_log",
    [TYPE.PENDING_APPOINTMENTS]: "report.schedule.pending_appointment",
    [TYPE.APPOINTMENT_DURATION]: "report.schedule.appointment_duration",

    // Communication Reports
    [TYPE.REMINDERS_DETAIL]: "report.comm.reminders",
    [TYPE.FAILED_EMAILS]: "report.comm.failed_emails",

    // Staff Reports
    [TYPE.TIME_SHEET]: "report.staff.timesheet",
    [TYPE.TIME_SHEETS]: "report.staff.timesheet"
};

export default {
    REPORT_PERMISSIONS
};
